export default __webpack_public_path__ + "938a42b71389b25d2f9290d93c2eef3d.svg";